import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from "@/core/Http/BzbsApi.js";
import { map } from "rxjs/operators";

/**
 * @method apiGetPDPAVersion
 * @method apiGetPDPAContent
 */

export default {
    apiGetBlobConfig: function(path) {
        var url = ConfigManager.getBlobUrl() + path;
        console.log('url', url);
        return BzbsApi.connectBzbsGetBlob(url).pipe(map(res => res.data));
    },
}
